import { formatDateFrom } from '@zola-helpers/client/dist/es/util/dateUtils';
import StarRatings from '@zola/zola-ui/src/components/StarRatings/StarRatings';
import { CheckIcon } from '@zola/zola-ui/src/components/SvgIconsV3/Check';
import COLORS from '@zola/zola-ui/src/styles/emotion/colors3';

import type { LightboxPhoto } from '~/components/common/ui/CoverGalleryV2/types';
import type { ReviewPhotoView } from '~/types/responseTypes';

import { HeaderReview, Bullet, VerifiedReview } from './CoverGalleryV2.styles';

type HeaderReviewInfoProps = {
  openPhoto: LightboxPhoto | null;
  showReviewPhotos: boolean;
};

/**
 * Storefront review info on lightbox header, including rating, reviewer name, and review date
 */
export const HeaderReviewInfo = ({
  openPhoto,
  showReviewPhotos,
}: HeaderReviewInfoProps): JSX.Element => {
  const { overallRating, reviewerName, sentToBvAt } = (openPhoto as ReviewPhotoView) || {};
  const reviewDate = sentToBvAt ? formatDateFrom(sentToBvAt, new Date()) : null;

  return showReviewPhotos ? (
    <HeaderReview>
      <StarRatings
        totalStars={5}
        activeStars={overallRating}
        reviewCount=""
        fillColor={COLORS.YELLOW_100}
      />
      <Bullet>&bull;</Bullet>
      <VerifiedReview>
        <CheckIcon height={20} title="" width={20} />
        <span>Verified review</span>
      </VerifiedReview>
      <Bullet>&bull;</Bullet>
      <span>{reviewerName}</span>
      {reviewDate && (
        <>
          <Bullet>&bull;</Bullet>
          <span>{reviewDate}</span>
        </>
      )}
    </HeaderReview>
  ) : (
    <></>
  );
};
